const APP_NAME = 'Wecasa web';

export default {
  AMPLITUDE_API_KEY: import.meta.env.VITE_REACT_APP_AMPLITUDE_API_KEY || '',
  AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY: import.meta.env.VITE_REACT_APP_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY || '',
  AMPLITUDE_TRACKING_SERVER_URL: import.meta.env.VITE_REACT_APP_AMPLITUDE_TRACKING_SERVER_URL || '',
  AMPLITUDE_EXPERIMENT_SERVER_URL: import.meta.env.VITE_REACT_APP_AMPLITUDE_EXPERIMENT_SERVER_URL || '',
  AMPLITUDE_FLAGS_SERVER_URL: import.meta.env.VITE_REACT_APP_AMPLITUDE_FLAGS_SERVER_URL || '',
  APP_NAME,
  APPLE_CLIENT_ID: import.meta.env.VITE_REACT_APP_APPLE_CLIENT_ID || '',
  ENABLE_REDUX_LOGGER: import.meta.env.VITE_REACT_APP_ENABLE_REDUX_LOGGER,
  FACEBOOK_APP_ID: import.meta.env.VITE_REACT_APP_FACEBOOK_APP_ID || '',
  GOOGLE_CLIENT_ID: import.meta.env.VITE_REACT_APP_GOOGLE_CLIENT_ID || '',
  SENTRY_API_KEY: import.meta.env.VITE_REACT_APP_SENTRY_API_KEY || '',
  WOOSMAP_API_KEY: import.meta.env.VITE_REACT_APP_WOOSMAP_API_KEY || '',
};
